// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__Zqin1","newSingleInfo":"Home_newSingleInfo__jH9HQ"};